import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import './JCBLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var JCBLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "JCBLogo", src: logo, alt: strings.app.name });
};
